export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-white/5 py-8"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-4xl font-semibold uppercase tracking-tight text-outline md:text-6xl">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-white/25" />
          </span>
        ))}
      </div>
    </div>
  );
};
